
import React from 'react'
import { FiChevronRight } from 'react-icons/fi' 

export const Paginate = () => {

    return (
        <div className='paginate'>
            <ul>
                <li className='active'><div>1</div></li>
                <li><div>2</div></li>
                <li><div>3</div></li>
                <li><div>4</div></li>
                <li><div>5</div></li>
                <li><div>6</div></li>
                <li><div>7</div></li>
                <li><div>8</div></li>
                <li><div>9</div></li>
                <li><div>10</div></li>
                <li><div><FiChevronRight /></div></li>
            </ul>
        </div>
    )
}